import React from 'react';
import ProductPage from '../components/ProductPage';

const BoilerCover = () => (
  <ProductPage
    eyebrow="Boiler & Home System Plans"
    title={<>Maintenance plans for your <span className="text-[#FF5C39]">boiler</span> and heating system</>}
    tagline="Annual boiler service and support for your central heating, arranged through our UK network of qualified engineers. Two plans available: Boiler Only and Boiler + Plumbing & Drainage. This is a maintenance service agreement — not an insurance product."
    heroImage="https://images.unsplash.com/photo-1594233078955-e1f73a02ebb2?w=1400&q=80"
    monthlyPrice="Call to discuss"
    annualPrice="From £190.00"
    badge={{ top: 'Call to arrange', value: '0113 548 7557' }}
    includes={[
      'Boiler Only — annual plan £190.00',
      'Boiler + Plumbing & Drainage — annual plan £249.99',
      'Repairs and maintenance arranged through qualified engineers',
      'Radiators, pumps, valves and controls (as per plan T&Cs)',
      'Priority booking within engineer availability',
      'Monthly payment options available on request — please call',
      'Cancel any time — 14-day cooling off period',
      'Customer service Monday–Friday, 9am–5pm',
    ]}
    notCovered={[
      'Boilers over 15 years old (subject to survey)',
      'Commercial-grade heating systems',
      'Underfloor heating (available as add-on where offered)',
      'Faults caused by hard water without protection',
    ]}
  />
);

export default BoilerCover;
